import { styled } from "@mui/material/styles";
import { Box, Grid2, Typography } from "@mui/material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const ContentGrid = styled(Grid2)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const ContentRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  gap: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    justifyContent: "center",
  },
}));

export const ContentColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "24px",
  color: theme.palette.text.primary,
  borderBottom: theme.palette.border,
  height: "50px",
  textAlign: "center",
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

export const EmailLink = styled(Typography)(({ theme }) => ({
  ...theme.body,
  marginTop: theme.spacing(1),
  textDecoration: "underline",
  cursor: "pointer",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const PodcastImage = styled("img")(({ theme }) => ({
  margin: "0 auto",
  height: "500px",
  width: "500px",
  objectFit: "contain",
  borderRadius: theme.spacing(4),
  [theme.breakpoints.down("lg")]: {
    height: "450px",
    width: "450px",
  },
  [theme.breakpoints.down("md")]: {
    height: "400px",
    width: "400px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "350px",
    width: "350px",
  },
}));

export const LinkBoxWrapper = styled(Box)({
  margin: "0 auto",
});
